export default __webpack_public_path__ + "static/media/logo_sidebar_expanded.98f1633c.png";